import { ThemeColors } from './token.types';

export const darkTheme = {
    // Surface colors
    colorNeutralBackground1: '#292929',
    colorNeutralBackground1Selected: '#0f3a5f',
    colorNeutralBackground1Hover: '#2d2d2d',
    colorNeutralBackground1Pressed: '#3a3a3a',
    colorNeutralBackground2: '#1f1f1f',
    colorNeutralBackground3: '#141414',
    colorNeutralBackground4: '#424242',
    colorNeutralBackground6: '##33333',

    // Text colors
    colorNeutralForeground1: '#ffffff',
    colorNeutralForeground1Disabled: '#616161',
    colorNeutralForeground2: '#c7c7c7',
    colorNeutralForeground3: '#a6a6a6',
    colorNeutralForegroundInverted: '#000000',
    colorNeutralForegroundStaticInverted: '#ffffff',
    colorNeutralGrey44: '#999999',

    // Border colors
    colorNeutralStroke1: '#5a5a5a',
    colorNeutralStroke1Disabled: '#3a3a3a',
    colorNeutralStroke2: '#4a4a4a',
    colorNeutralStrokeAccessible: '#a6a6a6',

    // Brand colors
    colorBrand60: '#4ba91f', // Very light brand color for subtle elements
    colorBrand70: '#389120', // Lighter brand color for hover states
    colorBrand80: '#26890D', // Primary brand color
    colorBrand90: '#1a5a0b', // Darker brand color for buttons/interactive elements
    colorBrand100: '#0f3006', // Very dark brand color for pressed states
    colorBrandShade10: '#21750B',
    colorBrandStroke: '#A2C993',

    // Tags
    colorGreenBackground: '#0E3B0E',
    colorGreenForeground: '#6BB700',
    colorGreenBorder: '#4A7C4A',
    colorBlueBackground: '#0F2A44',
    colorBlueForeground: '#4CC2FF',
    colorBlueBorder: '#2B5A8C',
    colorRedBackground: '#381C1B',
    colorRedForeground: '#FF4B4B',
    colorRedBorder: '#8C4A4A',
    colorDangerForeGround1: '#DC626D',
    colorErrorForeground: '#D74654',
    colorYellowBackground: '#3D2F00',
    colorYellowForeground: '#EAA300',
    colorYellowBorder: '#8B6914',
    colorOrangeBackground: '#3D2F00',
    colorOrangeForeground: '#FCE100',
    colorOrangeBorder: '#8B6914',
    colorMarigoldBackground: '#3D2F00',
    colorMarigoldForeground: '#EAA300',
    colorMarigoldBorder: '#8B6914',
    colorMarigoldForeground2: '#835B00',
    colorPinkBackground: '#5a2847',
    colorPinkForeground: '#f7c0e3',
    colorPinkBorder: '#8b4a6f',
    colorPurpleForeground: '#7840B8',
    colorPurpleBorder: '#7840B8',
    colorWarningBorder: '#FDCFB4',
    colorWarningForeground2: '#8A3707',

    // Badge specific colors
    colorNeutralBackground5: '#3a3a3a',
    colorNeutralBackground3Pressed: '#4a4a4a',

    // Status colors
    colorPaletteGreenBackground3: '#6bb700',
    colorPaletteYellowBackground3: '#fce100',
    colorPaletteRedBackground3: '#ff4b4b',
    colorPaletteBlueBackground3: '#4cc2ff',

    //Category specific colors
    colorCalendar1: '#86bc25',
    colorCalendar2: '#ed8b00',
    colorCalendar3: '#00a3e0',
    colorCalendar4: '#ff60aa',
    colorCalendar5: '#a0dcff',
    colorCalendar6: '#fccd00',
    colorCalendar7: '#ff6767',
    colorCalendar8: '#00abab',
    colorCalendar9: '#d6d6d6',
    colorCalendarPurple: '#b36fff',

    brandJewelGradient: 'linear-gradient(180deg, #1c3d26 0%, #046a38 100%)',

    // Spinner colors
    spinnerTrackColor: '#44952E',
    spinnerTailColor: '#1E4B12',

    colorSuccessBackground1: '#DBFBD3',
    colorSuccessBorder1: '#7DF060',
    colorSuccessForeground1: '#21750B',

    colorBrandBackground2: '#CEE3C5',
    colorBrandForeground2: '#236911',

    colorNeutralForeground4: '#707070',

    warningForeground1: '#F98845',

    // Custom elements
    rulesDialogLinkColor: '#4ba91f',
    robinChatColor: '#4ba91f',
    refreshButton: '#4ba91f',
    widgetCardHeaderDescription: '#a6a6a6',
    buttonDisabledColor: '#a3a3a3',
    badgecountColor: '#c7c7c7',
    asterix: '#FF5252',
} satisfies ThemeColors;
